var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Qcontainer"},[_c('span',{staticClass:"QQStyle"},[_vm._v("Q")]),_c('span',{staticClass:"QQText"},[_vm._v(_vm._s(_vm.question))])])}
var staticRenderFns = []

export { render, staticRenderFns }